import { Formik, Form } from 'formik';
import { DateBox, TextArea, TextBox } from '../../shared/controls/form';
import SelectBox from '../../shared/controls/form/selectBox';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import { validationSchemaDeal } from './validationSchema';
import { useSelector } from 'react-redux';
import apiServices from '../../services/service';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import { formatUSCurrency } from '../../shared/constants';

const DealForm = ({
  formData,
  selectedOptions,
  handleSubmit,
  handleChangeForm,
  handleChange,
  errormsg,
  contactOptions,
}) => {
  const industryTypeDropdown = useSelector(getGenericMasterFilteredListByKey('Industry'));

  const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));

  const {
    options: accountOptions,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown,
    responseKey: 'accountList',
  });

  const {
    options: campaignSource,
    isLoading: isCampaignLoading,
    handleSearch: handleCampaignSearch,
    handleScroll: handleCampaignScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getCampaignDropdown,
    responseKey: 'campaignList',
  });
  const reachOutForMarketingOptions = [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' },
  ];

  const forecastCategoryDropdown = useSelector(
    getGenericMasterFilteredListByKey('ForecastCategory')
  );

  const projectTypeDropdown = useSelector(getGenericMasterFilteredListByKey('ProjectTypeCrm'));

  const stageDropdown = useSelector(getGenericMasterFilteredListByKey('Stage'));

  const owner = useSelector(getActiveOwners);

  const mapBooleanToOption = (value) => {
    if (value === true) {
      return 'Yes';
    } else if (value === false) {
      return 'No';
    } else {
      return value;
    }
  };

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaDeal}
    >
      <Form>
        <div className="collapse_card">
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row gx-3">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/dealIcon.svg" alt="" />
                      Opportunity Information
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Opportunity Name'}
                            name={'name'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Name'}
                            value={formData.name}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.name}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Account Name'}
                            name={'accountId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.account || '--'
                                : formData?.account || 'Select Account Name'
                            }
                            isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.accountId}
                            handleSelect={handleChange}
                            options={accountOptions}
                            optionKeys={['id', 'name']}
                            errormsg={errormsg?.accountId}
                            isLoading={isAccountLoading}
                            onSearch={handleAccountSearch}
                            onScrollToBottom={handleAccountScroll}
                            fieldType={'accountId'}
                            fieldId={formData?.accountId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Contact Name'}
                            name={'contactId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.contact || '--'
                                : formData?.contact || 'Select Contact Name'
                            }
                            isRequired={true}
                            disabled={formData?.type === 'view' || !formData?.accountId}
                            selectedOptions={selectedOptions?.contactId}
                            handleSelect={handleChange}
                            options={contactOptions}
                            optionKeys={['id', 'name']}
                            errormsg={errormsg?.contactId}
                            fieldType={'contactId'}
                            fieldId={formData?.contactId}
                            view={formData?.type === 'view'}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Project Type'}
                            name={'projectTypeId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.projectType || '--'
                                : formData?.projectType || 'Select Project Type'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.projectTypeId}
                            handleSelect={handleChange}
                            options={projectTypeDropdown}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.projectTypeId}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Next Step'}
                            name={'nextStep'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Next Step'}
                            value={formData.nextStep}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.nextStep}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Forecast Category'}
                            name={'forecastCategoryId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.forecastCategory || '--'
                                : formData?.forecastCategory || 'Select Forecast Category'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.forecastCategoryId}
                            handleSelect={handleChange}
                            options={forecastCategoryDropdown}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.forecastCategoryId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            label={'Amount'}
                            name={'amount'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Amount'}
                            value={
                              formData?.type === 'view'
                                ? formatUSCurrency(formData?.amount)
                                : (formData?.amount ?? '')
                            }
                            handleChange={handleChangeForm}
                            maxLength={16}
                            errormsg={errormsg?.amount}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Stage'}
                            name={'stageId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.stage || '--'
                                : formData?.stage || 'Select Stage'
                            }
                            isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.stageId}
                            handleSelect={handleChange}
                            options={stageDropdown}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.stageId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            label={'Probability'}
                            name={'probability'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Probability (%)'}
                            value={
                              formData?.type === 'view'
                                ? `${formData?.probability ?? ''}%`
                                : (formData?.probability ?? '')
                            }
                            handleChange={handleChangeForm}
                            maxLength={3}
                            errormsg={errormsg?.probability}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <label>Closing Date</label>
                          {formData?.type === 'view' ? (
                            <div>
                              {formData?.closingDate
                                ? new Date(formData.closingDate).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                  })
                                : '--'}
                            </div>
                          ) : (
                            <div className="dtBox">
                              <DateBox
                                name="closingDate"
                                placeholder="Enter Closing Date (MM/DD/YYYY)"
                                value={
                                  formData?.closingDate
                                    ? formData?.closingDate.substring(0, 10)
                                    : ''
                                }
                                handleChange={handleChangeForm}
                                errormsg={errormsg?.closingDate}
                                disabled={formData?.type === 'view'}
                                minDate={
                                  formData.type === 'edit'
                                    ? undefined
                                    : new Date().toISOString().split('T')[0]
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            label={'Expected Revenue'}
                            name={'expectedRevenue'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Expected Revenue'
                            }
                            value={
                              formData?.type === 'view'
                                ? formatUSCurrency(formData?.expectedRevenue)
                                : (formData?.expectedRevenue ?? '')
                            }
                            handleChange={handleChangeForm}
                            maxLength={16}
                            errormsg={errormsg?.expectedRevenue}
                            disabled={formData?.type === 'view'}
                          />
                          {/* </div> */}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Campaign Source'}
                            name={'campaignSourceId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.campaignSource || '--'
                                : formData?.campaignSource || 'Campaign Source'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.campaignSourceId}
                            handleSelect={handleChange}
                            options={campaignSource}
                            optionKeys={['id', 'campaignName']}
                            errormsg={errormsg?.campaignSourceId}
                            isLoading={isCampaignLoading}
                            onSearch={handleCampaignSearch}
                            onScrollToBottom={handleCampaignScroll}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Reach Out for Marketing'}
                            name={'reachOutForMarketingId'}
                            placeholder={
                              formData?.type === 'view'
                                ? mapBooleanToOption(formData?.reachOutForMarketing) || '--'
                                : mapBooleanToOption(formData?.reachOutForMarketing) || 'Select'
                                  ? mapBooleanToOption(formData?.reachOutForMarketing) || 'Select'
                                  : 'Select' // Show "Select" as placeholder when no value is selected
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.reachOutForMarketingId}
                            handleSelect={handleChange}
                            options={reachOutForMarketingOptions}
                            optionKeys={['id', 'name']}
                            errormsg={errormsg?.reachOutForMarketingId}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="infoBox">
                      <div className="addlead-header pd_card">
                        <label htmlFor="" className="flex-div align-items-center">
                          <img className="me-2" src="../assets/images/companyInfo.svg" alt="" />
                          General Information
                        </label>
                      </div>
                      <div className="leadcontent pd_card leadDetailInfo ">
                        <>
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                              <div className="input-container">
                                <SelectBox
                                  label={'Opportunity Owner'}
                                  name={'ownerId'}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.owner || '--'
                                      : formData?.owner || 'Select Opportunity Owner'
                                  }
                                  disabled={formData?.type === 'view'}
                                  selectedOptions={selectedOptions.ownerId}
                                  handleSelect={handleChange}
                                  options={owner}
                                  optionKeys={['userId', 'display_name']}
                                  errormsg={errormsg?.ownerId}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                              <div className="input-container">
                                <SelectBox
                                  label={'Industry'}
                                  name={'industryId'}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.industry || '--'
                                      : formData?.industry || 'Select Industry'
                                  }
                                  isRequired={true}
                                  disabled={formData?.type === 'view'}
                                  selectedOptions={selectedOptions.industryId}
                                  handleSelect={handleChange}
                                  options={industryTypeDropdown}
                                  optionKeys={['id', 'displayName']}
                                  errormsg={errormsg?.industryId}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                              <div className="input-container">
                                <TextBox
                                  label={'Business Type'}
                                  name={'businessType'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Business Type'
                                  }
                                  value={formData.businessType}
                                  handleChange={handleChangeForm}
                                  maxLength={250}
                                  errormsg={errormsg?.businessType}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                              <div className="input-container">
                                <SelectBox
                                  label={'Lead Source'}
                                  name={'leadSourceId'}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.leadSource || '--'
                                      : formData?.leadSource || 'Select Lead Source'
                                  }
                                  isRequired={true}
                                  disabled={formData?.type === 'view'}
                                  selectedOptions={selectedOptions.leadSourceId}
                                  handleSelect={handleChange}
                                  options={leadSourceDropdown}
                                  optionKeys={['id', 'displayName']}
                                  errormsg={errormsg?.leadSourceId}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                              <div className="input-container">
                                <TextBox
                                  isRequired={true}
                                  label={'Source Name'}
                                  name={'sourceName'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Source Name'
                                  }
                                  value={formData?.sourceName}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.sourceName}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                              <div className="input-container">
                                <TextBox
                                  // isRequired={true}
                                  label={'Other Source Name'}
                                  name={'otherSourceName'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Other Source Name'
                                  }
                                  value={formData.otherSourceName}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.otherSourceName}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                              <div className="input-container">
                                <TextBox
                                  label={'Line Of Business'}
                                  name={'lineOfBusiness'}
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter Line Of Business'
                                  }
                                  value={formData.lineOfBusiness}
                                  handleChange={handleChangeForm}
                                  maxLength={250}
                                  errormsg={errormsg?.lineOfBusiness}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/dealIcon.svg" alt="" />
                      Opportunity Details
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo notesLabel">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Description'}
                              name={'description'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                              value={formData.description}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.description}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Technology Stack'}
                              name={'technologyStack'}
                              placeholder={
                                formData?.type === 'view' ? '--' : 'Enter Technology Details'
                              }
                              value={formData.technologyStack}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.technologyStack}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default DealForm;
